import { memo } from 'react';
import { FormattedMessage } from 'react-intl';
import { Text } from '@library';
import AlertIcon from './icons/AlertIcon';
import styles from './FormAlert.module.scss';
import HorizontalLayout from './layout/HorizontalLayout';

const FormAlert = ({ message }: { message: string }) => {
    return (
        <div className={styles.formAlert}>
            <HorizontalLayout align="center">
                <div className={styles.icon}>
                    <AlertIcon />
                </div>
                <Text primary>
                    <span className={styles.message}>
                        <FormattedMessage id={message} />
                    </span>
                </Text>
            </HorizontalLayout>
        </div>
    );
};

export default memo(FormAlert);
